import http from '../http'

/**
 * 获取产品
 * @param  {number} id 产品主键
}
 */
export const getProduct = id => {
    return http.get(`/api/gm/product/get/${id}`)
}
/**
 * 获取产品列表(未删除)
 */
export const getList = () => {
    return http.get('/api/gm/product/getlist')
}
/**
 * 获取产品列表(已删除)
 */
export const getDelList = () => {
    return http.get('/api/gm/product/getdellist')
}
/**
 * 添加产品
 * @param {FormData} product 用户,例:  {
    "id": 0,
    "name": '产品名',
    "image": "图片",
    "CatalogTree":[
    {
    "id":0,
    "label":"名称",
    "type":"类型名",
    "childs":[],
    },
    ]
}
*/
export const addProduct = product => {
    return http.post('/api/gm/product/add', product, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

/**
 * 修改产品
 * @param {FormData} product 用户,例:  {
    "id": 产品主键,
    "name": '产品名',
    "image": "图片",
    "CatalogTree":[
    {
    "id":0,
    "label":"名称",
    "type":"类型名",
    "childs":[],
    },
    ]
}
*/
export const editProduct = product => {
    return http.post('/api/gm/product/edit', product, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}
/**
 * 加入回收站
 * @param  {number} id 产品主键
}
 */
export const delProduct = id => {
    return http.get(`/api/gm/product/del/${id}`)
}
/**
 * 恢复
 * @param  {number} id 产品主键
}
 */
export const recoveryProduct = id => {
    return http.get(`/api/gm/product/Recovery/${id}`)
}
/**
 * 彻底删除
 * @param  {number} id 产品主键
}
 */
export const deleteProduct = id => {
    return http.get(`/api/gm/product/delete/${id}`)
}



// WEBPACK FOOTER //
// ./src/api/gm/api-product.js